import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_inventory_material_grid_ComponentContextService } from './FootprintManager.inventory_material_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_inventory_material_gridComponentEntity {
  WarehouseId?: number, MaterialId?: number, PackagedId?: number, GrossWeight?: number, PackagedAmount?: number, Material?: { Description?: string, LookupCode?: string, Name?: string, ProjectId?: number, Project?: { LookupCode?: string }, Status?: { Name?: string } }, Packaging?: { ShortName?: string }, Warehouse?: { Name?: string }, WeightUom?: { Short_name?: string }}

interface IFootprintManager_inventory_material_gridComponentInParams {
  ownerId?: number, projectId?: number, warehouseId?: number, materialIds?: number[]}


class FootprintManager_inventory_material_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_inventory_material_gridComponent;
  entity: IFootprintManager_inventory_material_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    warehouse: null,
    project: null,
    material: null,
    status: null,
    total_packaged_amount: null,
    available_packaged_amount: null,
    soft_allocated: null,
    inactive: null,
    non_allocatable: null,
    packaging_available_base_amount: null,
    packaging: null,
    total_available_base_amount: null,
    gross_weight: null,
    weight_uom: null,
    material_description: null,
  }



  constructor(
    grid: FootprintManager_inventory_material_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_inventory_material_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.material,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.status = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.status,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.total_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.total_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.available_packaged_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.available_packaged_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.soft_allocated = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.soft_allocated,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.inactive = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.inactive,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.non_allocatable = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.non_allocatable,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaging_available_base_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging_available_base_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.packaging = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.packaging,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.total_available_base_amount = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.total_available_base_amount,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.gross_weight = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.gross_weight,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.weight_uom = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.weight_uom,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.material_description = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.material_description,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_inventory_material_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.WarehouseId,this.entity.MaterialId,this.entity.PackagedId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_inventory_material_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.WarehouseId,this.entity.MaterialId,this.entity.PackagedId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'WarehouseId',this.entity.WarehouseId);
    set($resultKey, 'MaterialId',this.entity.MaterialId);
    set($resultKey, 'PackagedId',this.entity.PackagedId);
    const inParams = {
      $keys:[$resultKey],
      fullTextSearch:  $grid.fullTextSearch ,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      materialIds:  $grid.inParams.materialIds ,
      skip:  null ,
      take:  null ,
    };
    const data = await this.$datasources.Inventory.ds_inventory_material_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_inventory_material_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.warehouse.displayControl as TextModel).text = $row.entity.Warehouse?.Name;
    (this.cells.project.displayControl as TextModel).text = $row.entity.Material?.Project?.LookupCode;
    (this.cells.material.displayControl as TextModel).text = $row.entity.Material?.LookupCode;
    (this.cells.status.displayControl as TextModel).text = $row.entity.Material.Status?.Name;
    (this.cells.total_packaged_amount.displayControl as TextModel).text = $row.entity.PackagedAmount?.toString();
    (this.cells.packaging.displayControl as TextModel).text = $row.entity.Packaging?.ShortName;
    (this.cells.gross_weight.displayControl as TextModel).text = $row.entity.GrossWeight?.toString();
    (this.cells.weight_uom.displayControl as TextModel).text = $row.entity.WeightUom?.Short_name;
    (this.cells.material_description.displayControl as TextModel).text = $row.entity.Material?.Description;

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'project' : {
        this.on_project_clicked();
        break;
      }
      case 'material' : {
        this.on_material_clicked();
        break;
      }
    }
  }

  //#region private flows
  on_material_clicked(event = null) {
    return this.on_material_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_material_clickedInternal(
    $row: FootprintManager_inventory_material_gridComponentRowModel,
  $grid: FootprintManager_inventory_material_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_material_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_material_hub({materialId: $row.entity.MaterialId});
  }
  on_project_clicked(event = null) {
    return this.on_project_clickedInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_clickedInternal(
    $row: FootprintManager_inventory_material_gridComponentRowModel,
  $grid: FootprintManager_inventory_material_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_material_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  $shell.FootprintManager.opensingle_project_hub({projectId: $row.entity.Material.ProjectId})
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-inventory_material_grid',
  templateUrl: './FootprintManager.inventory_material_grid.component.html'
})
export class FootprintManager_inventory_material_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_inventory_material_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['compact','fit-content-table']);

  fullTextSearch: string;

  inParams: IFootprintManager_inventory_material_gridComponentInParams = { ownerId: null, projectId: null, warehouseId: null, materialIds: [] };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       material: new GridHeaderModel(new HeaderStyles(null, null), 'material', 'Material', false, false, null, false),       status: new GridHeaderModel(new HeaderStyles(null, null), 'status', 'Status', false, false, null, false),       total_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'total_packaged_amount', 'Total', false, false, null, false),       available_packaged_amount: new GridHeaderModel(new HeaderStyles(null, null), 'available_packaged_amount', 'Available', false, false, null, false),       soft_allocated: new GridHeaderModel(new HeaderStyles(null, null), 'soft_allocated', 'Soft allocated', false, false, null, false),       inactive: new GridHeaderModel(new HeaderStyles(null, null), 'inactive', 'Inactive', false, false, null, false),       non_allocatable: new GridHeaderModel(new HeaderStyles(null, null), 'non_allocatable', 'Non allocatable', false, false, null, false),       packaging_available_base_amount: new GridHeaderModel(new HeaderStyles(null, null), 'packaging_available_base_amount', 'Packaging available base', false, false, null, false),       packaging: new GridHeaderModel(new HeaderStyles(null, null), 'packaging', 'Packaging', false, false, null, false),       total_available_base_amount: new GridHeaderModel(new HeaderStyles(null, null), 'total_available_base_amount', 'Total available base', false, false, null, false),       gross_weight: new GridHeaderModel(new HeaderStyles(null, null), 'gross_weight', 'Gross weight', false, false, null, false),       weight_uom: new GridHeaderModel(new HeaderStyles(null, null), 'weight_uom', 'Weight UOM', false, false, null, false),       material_description: new GridHeaderModel(new HeaderStyles(null, null), 'material_description', 'Material description', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_inventory_material_gridComponentRowModel[] = [];

  @Input('ownerId') set $inParams_ownerId(value: any) {
    this.inParams['ownerId'] = value;
  }
  get $inParams_ownerId(): any {
    return this.inParams['ownerId'] ;
  }
  @Input('projectId') set $inParams_projectId(value: any) {
    this.inParams['projectId'] = value;
  }
  get $inParams_projectId(): any {
    return this.inParams['projectId'] ;
  }
  @Input('warehouseId') set $inParams_warehouseId(value: any) {
    this.inParams['warehouseId'] = value;
  }
  get $inParams_warehouseId(): any {
    return this.inParams['warehouseId'] ;
  }
  @Input('materialIds') set $inParams_materialIds(value: any) {
    this.inParams['materialIds'] = value;
  }
  get $inParams_materialIds(): any {
    return this.inParams['materialIds'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_inventory_material_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Inventory by material';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 50;


    await this.on_init();
    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      fullTextSearch:  $grid.fullTextSearch ,
      ownerId:  $grid.inParams.ownerId ,
      projectId:  $grid.inParams.projectId ,
      warehouseId:  $grid.inParams.warehouseId ,
      materialIds:  $grid.inParams.materialIds ,
      skip:  null ,
      take:  null ,
    };
    try {
      const data = await this.$datasources.Inventory.ds_inventory_material_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_inventory_material_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_inventory_material_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_loaded();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $grid: FootprintManager_inventory_material_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_material_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  }
  on_export_flow(event = null) {
    return this.on_export_flowInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_export_flowInternal(
    $grid: FootprintManager_inventory_material_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_material_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  
  const exportLimit = $settings.FootprintManager.ExcelExportLimit
  var topLimit: number = 5000;
  
  // Initialize
  var wb = $event;
  var transactions = [];
  var allData: any[] = [];
  var lot_availability: any[] = [];
  var inboundOrders: any[] = [];
  var freshData: any[] = [];
  
  // Set Date/Time Formats
  const dateFormat = `${$settings.FootprintManager.DateFormat}`;
  
  
  try {
  
      var totalRecords = (await $datasources.Inventory.ds_inventory_material_grid.get({
          ownerId: $grid.inParams.ownerId,
          projectId: $grid.inParams.projectId,
          warehouseId: $grid.inParams.warehouseId,
          materialIds: $grid.inParams.materialIds,
          fullTextSearch: $grid.fullTextSearch,
          take: 1
      })).totalCount;
  
  
      if (totalRecords > exportLimit) {
          var exportApproval = true;
          (await $shell.Inventory.openInfoDialog(`Export limitation of ${exportLimit} exceeded`, `Excel will only export ${exportLimit} records`));
      } else {
          exportApproval = true;
      }
  
  
      if (exportApproval) {
          var recordsTaken: number = 0;
          var remainingRecords: number = Math.min(exportLimit, totalRecords);
          do {
              var response = await $datasources.Inventory.ds_inventory_material_grid.get({
                  ownerId: $grid.inParams.ownerId,
                  projectId: $grid.inParams.projectId,
                  warehouseId: $grid.inParams.warehouseId,
                  materialIds: $grid.inParams.materialIds,
                  fullTextSearch: $grid.fullTextSearch,
                  take: Math.min(remainingRecords, topLimit),
                  skip: recordsTaken
              });
              allData = allData.concat(response.result);
              recordsTaken += response.result.length
              remainingRecords -= response.result.length
  
          } while (remainingRecords > 0 && response.result.length > 0)
  
              // Function to chunk an array into smaller arrays of a specified size
          function chunkArray<T>(array: T[], chunkSize: number): T[][] {
              const chunks: T[][] = [];
              for (let i = 0; i < array.length; i += chunkSize) {
                  chunks.push(array.slice(i, i + chunkSize));
              }
              return chunks;
          }
  
             // Main function to get the aggregated results
          async function getAggregatedInventory(allData: any[], chunkSize: number) {
              const materialIds = [...new Set(allData.map(a => Number(a.MaterialId)))];
              const packagedIds = [...new Set(allData.map(a => Number(a.PackagedId)))];
              const warehouseIds = [...new Set(allData.map(a => Number(a.WarehouseId)))];
  
              // Split the arrays into smaller chunks
              const materialIdChunks = chunkArray(materialIds, chunkSize);
              const packagedIdChunks = chunkArray(packagedIds, chunkSize);
              const warehouseIdChunks = chunkArray(warehouseIds, chunkSize);
  
              let aggregatedResults: any[] = [];
  
              // Helper function to handle HTTP calls
              async function fetchChunk(materialIds: number[], packagedIds: number[], warehouseIds: number[]) {
                  const response = await $datasources.Inventory.ds_get_available_inventory_by_materialIds_packagedIds_warehouseIds_batched.get({
                      materialIds,
                      packagedIds,
                      warehouseIds
                  });
                  return response.result;
              }
  
              // Loop through the chunks and make HTTP calls
              for (let i = 0; i < materialIdChunks.length; i++) {
                  for (let j = 0; j < packagedIdChunks.length; j++) {
                      for (let k = 0; k < warehouseIdChunks.length; k++) {
                          const materialIdChunk = materialIdChunks[i];
                          const packagedIdChunk = packagedIdChunks[j];
                          const warehouseIdChunk = warehouseIdChunks[k];
  
                          const result = await fetchChunk(materialIdChunk, packagedIdChunk, warehouseIdChunk);
                          aggregatedResults = aggregatedResults.concat(result);
                      }
                  }
              }
  
              return aggregatedResults;
          }
  
          
          const chunkSize = 500; // Adjust chunk size as needed
          let material_availability_totals: any[] = [];
  
          await getAggregatedInventory(allData, chunkSize)
              .then(result => {
                  material_availability_totals = result;
              })
              .catch(error => {
                  console.error("Error fetching inventory:", error);
              });
  
  
  
          // const materialIds = [...new Set(allData.map(a => a.MaterialId))]
          // const packagedIds = [...new Set(allData.map(a => a.PackagedId))]
          // const warehouseIds = [...new Set(allData.map(a => a.WarehouseId))]
  
          // let material_availability_totals = (await $datasources.Inventory.ds_get_available_inventory_by_materialIds_packagedIds_warehouseIds_batched.get({
          //     materialIds: materialIds, packagedIds: packagedIds, warehouseIds: warehouseIds
          // })).result;
  
          // Compile all data into JSON
          for (let record of allData) {
  
              const material_availability = material_availability_totals.find(material => material.MaterialId === record.MaterialId
                  && material.WarehouseId === record.WarehouseId && material.PackagedId === record.PackagedId);
  
  
              transactions.push({
  
                  "Warehouse": record.Warehouse?.Name,
                  "Project": record.Material?.Project?.LookupCode,
                  "Material": record.Material?.LookupCode,
                  "Total": record.PackagedAmount,
                  "Available": material_availability?.TotalAvailablePackagedAmount,
                  "Soft Allocated": material_availability?.TotalSoftAllocatedPackagedAmount,
                  "Inactive": material_availability?.TotalInactivePackagedAmount,
                  "Packaging": record.Packaging?.ShortName,
                  "Gross Weight": record.GrossWeight,
                  "Weight Uom": record.WeightUom?.Short_name,
                  "Material Description": record.Material?.Description
              });
          }
          var ws = $utils.excel.json_to_sheet(transactions);
          $utils.excel.book_append_sheet(wb, ws, "InventoryExport");
      }
  
  
  } catch (error) {
      const errorMessage = $utils.isDefined(error?.error?.error) ? error?.error?.error.message : error;
      throw new Error(errorMessage);
  }
  
  }
  on_grid_data_loaded(event = null) {
    return this.on_grid_data_loadedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadedInternal(
    $grid: FootprintManager_inventory_material_gridComponent,
  
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_inventory_material_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  const packagedIds = ($grid.rows.map(r => r.entity?.PackagedId))
  const materialIds = ($grid.rows.map(r => r.entity?.MaterialId))
  const warehouseIds = ($grid.rows.map(r => r.entity?.WarehouseId))
  
  let material_availability = (await $datasources.Inventory.ds_get_available_inventory_by_materialIds_packagedIds_warehouseIds_batched.get({
      materialIds: materialIds, packagedIds: packagedIds, warehouseIds: warehouseIds
  })).result;
  
  let material_warehouse_availability = (await $datasources.Inventory.ds_get_available_inventory_by_materialIds_warehouseIds_batched.get({
      materialIds: materialIds, warehouseIds: warehouseIds
  })).result;
  
  let material_non_alloc_availability = (await $datasources.Inventory.ds_get_non_elligible_for_allocation_inventory_by_materialIds_packagingIds_warehouseIds_batched.get({
      materialIds: materialIds, packagingIds: packagedIds, warehouseIds: warehouseIds
  })).result;
  
  
  
  for (let row of $grid.rows) {
      for (let available of material_availability) {
          if (available.MaterialId === row.entity.MaterialId && available.WarehouseId === row.entity.WarehouseId && available.PackagedId === row.entity.PackagedId) {
  
              if ($utils.isDefined(available?.TotalAvailablePackagedAmount)) {
                  if (available?.TotalAvailablePackagedAmount < 0) {
                      row.cells.available_packaged_amount.displayControl.text = '0'
                  }
                  else {
                      row.cells.available_packaged_amount.displayControl.text = available?.TotalAvailablePackagedAmount?.toString();
                  }
              }
              else {
                  row.cells.available_packaged_amount.displayControl.text = '0'
              }
  
              if ($utils.isDefined(available?.TotalAvailableBaseAmount)) {
  
                  if (available?.TotalAvailableBaseAmount < 0) {
                      row.cells.packaging_available_base_amount.displayControl.text = '0'
                  }
                  else {
                      row.cells.packaging_available_base_amount.displayControl.text = available?.TotalAvailableBaseAmount?.toString();
                  }
              }
              else {
                  row.cells.packaging_available_base_amount.displayControl.text = '0'
              }
  
              row.cells.soft_allocated.displayControl.text = available?.TotalSoftAllocatedPackagedAmount?.toString();
              row.cells.inactive.displayControl.text = available?.TotalInactivePackagedAmount?.toString();
          }
      }
  
      for (let available of material_warehouse_availability) {
          if (available.MaterialId === row.entity.MaterialId && available.WarehouseId === row.entity.WarehouseId) {
              row.cells.total_available_base_amount.displayControl.text = available?.TotalAvailableBaseAmount?.toString();
          }
  
      }
  
      for (let available of material_non_alloc_availability) {
          if (available.MaterialId === row.entity.MaterialId && available.Location?.WarehouseId === row.entity.WarehouseId && available.PackagedId === row.entity.PackagedId) {
              row.cells.non_allocatable.displayControl.text = available?.TotalNonAllocatablePackagedAmount?.toString();
          }
      }
  
  }
  
  
  
  
  
  
  
  
  
  }
  //#endregion private flows


  async $exportExcel() {
    const wb: WorkBook = excelUtils.book_new();

    await this.on_export_flow(wb);

    writeExcelFile(wb, 'FootprintManager_inventory_material_gridComponent_export.xlsx');
  }
 
  close() {
    this.$finish.emit();
  }
}
